import { createFileRoute } from '@tanstack/react-router';
import { DisputesPage } from '../../features/disputes';

export const Route = createFileRoute('/portal/disputes/')({ component: DisputesPage });
